<template>
  <div>
    <v-container fluid class="auth-container">
      <v-card
        class="auth-wrapper"
        rounded="xl"
        elevation="6"
        :class="isSmAndUp ? { 'right-panel-active': !isLogin } : {}"
      >
        <!-- Sign In Form -->
        <div class="form-container sign-in-container">
          <v-card class="form-card" elevation="10" rounded="xl">
            <v-img
              src="/img/southernlogo.png"
              max-width="90"
              class="mx-auto mb-2"
              cover
              rounded="xl"
            />
            <h2 class="text-center mx-3 mb-1">
              Welcome to <span class="text-pink"> CMS </span>
            </h2>
            <p class="text-center text-caption text-grey-darken-1 mb-6">
              Sign in to continue to your account
            </p>

            <v-form ref="formLogin">
              <v-text-field
                v-model="emailLogin"
                :rules="[formRules.required, formRules.email]"
                label="Email address"
                prepend-inner-icon="mdi-email-outline"
                variant="outlined"
                density="compact"
                rounded="lg"
                @keyup.enter="dologin()"
                class="mb-3"
              />
              <v-text-field
                v-model="passwordLogin"
                label="Password"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showPassword = !showPassword"
                prepend-inner-icon="mdi-lock-outline"
                @keyup.enter="dologin()"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-5"
              />
              <v-btn
                color="#e93175"
                block
                rounded="lg"
                size="large"
                elevation="0"
                @click="dologin()"
                :loading="isLoading"
                :disabled="isLoading"
              >
                Sign In
                <v-icon end size="18">mdi-arrow-right</v-icon>
              </v-btn>

              <div class="mt-5 text-caption" v-if="!isSmAndUp">
                <div class="d-flex justify-center">
                  <p class="mr-1">Don't have an account yet?</p>
                  <a
                    class="text-green font-weight-medium"
                    @click="mobileChange()"
                    >Sign Up</a
                  >
                </div>
                <div class="text-green d-flex justify-center mt-3">
                  <a @click="doHome()">
                    <v-icon size="14" class="mr-1">mdi-home-outline</v-icon>Home
                  </a>
                </div>
              </div>
            </v-form>
          </v-card>
        </div>

        <!-- Sign Up Form -->
        <div
          class="form-container sign-up-container"
          :style="
            !isLogin
              ? { background: 'linear-gradient(135deg, #e93175, #d81b60)' }
              : {}
          "
        >
          <v-card class="form-card" elevation="10" rounded="xl">
            <h2 class="text-center mb-2">Create Account</h2>

            <!-- Step indicator -->
            <div class="d-flex align-center justify-center mb-1">
              <template v-for="n in 3" :key="n">
                <div
                  class="step-dot"
                  :class="{
                    'step-dot-active': n === step.id,
                    'step-dot-done': n < step.id,
                  }"
                >
                  <v-icon v-if="n < step.id" size="12" color="white"
                    >mdi-check</v-icon
                  >
                </div>
                <div
                  v-if="n < 3"
                  class="step-line"
                  :class="{ 'step-line-done': n < step.id }"
                ></div>
              </template>
            </div>
            <p class="text-caption text-center text-grey-darken-1 mb-5">
              Step {{ step.id }} of 3 — {{ step.name }}
            </p>

            <v-form ref="formInformation" v-show="step.id == 1">
              <v-text-field
                v-model="fname"
                label="First Name"
                prepend-inner-icon="mdi-account-outline"
                :rules="[formRules.required]"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-3"
              />
              <v-text-field
                v-model="mname"
                label="Middle Name(optional)"
                prepend-inner-icon="mdi-account-outline"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-3"
              />
              <v-text-field
                v-model="lname"
                label="Last Name"
                prepend-inner-icon="mdi-account-outline"
                :rules="[formRules.required]"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-3"
              />
              <v-btn
                color="#e93175"
                block
                rounded="lg"
                size="large"
                elevation="0"
                @click="next()"
                class="mb-2"
              >
                Next
                <v-icon end size="18">mdi-arrow-right</v-icon>
              </v-btn>
              <div
                class="mt-4 text-caption d-flex justify-center"
                v-if="!isSmAndUp"
              >
                <p class="mr-1">Already have an account?</p>
                <a class="text-green font-weight-medium" @click="mobileChange()"
                  >Sign In</a
                >
              </div>
            </v-form>

            <v-form ref="formRegister" v-show="step.id == 2">
              <v-autocomplete
                v-if="userType == 1"
                v-model="assignedModuleID"
                :rules="[formRules.required]"
                variant="outlined"
                clearable=""
                density="compact"
                class="rounded-lg mb-1"
                item-value="id"
                item-title="description"
                label="Role"
                color="#93CB5B"
                :items="assignedModulesList"
              >
              </v-autocomplete>
              <v-text-field
                v-model="email"
                label="Email"
                prepend-inner-icon="mdi-email-outline"
                :rules="[formRules.required, formRules.email]"
                @change="checkEmail()"
                :error-messages="emailError"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-3"
              />
              <v-text-field
                v-model="password"
                label="Password"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-inner="showPassword = !showPassword"
                :rules="[formRules.required, formRules.password]"
                prepend-inner-icon="mdi-lock-outline"
                variant="outlined"
                density="compact"
                rounded="lg"
                class="mb-3"
              />
              <v-text-field
                class="font-size-14 mb-5"
                color="#93CB5B"
                variant="outlined"
                density="compact"
                rounded="lg"
                v-model="confirmPassword"
                :rules="[
                  formRules.required,
                  formRules.confirmPassword(confirmPassword, password),
                ]"
                :type="showPasswordConfirm ? 'text' : 'password'"
                :append-inner-icon="
                  showPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'
                "
                @click:append-inner="showPasswordConfirm = !showPasswordConfirm"
                prepend-inner-icon="mdi-lock-outline"
                label="Confirm Password"
              ></v-text-field>
              <v-btn
                color="#e93175"
                block
                rounded="lg"
                size="large"
                elevation="0"
                @click="register()"
                class="mb-2"
                :loading="isLoading"
              >
                Sign Up
              </v-btn>
              <div
                class="mt-4 text-caption d-flex justify-center"
                v-if="!isSmAndUp"
              >
                <p class="mr-1">Already have an account?</p>
                <a class="text-green font-weight-medium" @click="mobileChange()"
                  >Sign In</a
                >
              </div>
            </v-form>

            <v-form
              ref="formOTP"
              v-show="step.id === 3"
              @submit.prevent="submitOTP"
            >
              <v-row class="mx-1 mt-1" justify="center">
                <v-col cols="12" class="pa-0 px-2 mb-3 text-center">
                  <v-icon color="pink" size="34" class="mb-2"
                    >mdi-email-check-outline</v-icon
                  >
                  <div style="font-size: 12px" class="text-grey-darken-1">
                    Please enter the OTP that was sent to your email address to
                    continue your system registration.
                  </div>
                </v-col>

                <v-col cols="12" class="mb-2 text-center">
                  <p class="text-caption text-grey mb-3">
                    Enter your One Time Pin
                  </p>

                  <div class="otp-wrapper">
                    <input
                      v-for="(digit, index) in otp"
                      :key="index"
                      type="tel"
                      inputmode="numeric"
                      maxlength="1"
                      v-model="otp[index]"
                      class="otp-input"
                      @input="onOtpInput($event, index)"
                    />
                  </div>
                </v-col>

                <v-col cols="12" class="pa-0 px-4 mt-2">
                  <v-btn
                    type="submit"
                    :loading="isLoading"
                    block
                    variant="flat"
                    color="#e93175"
                    size="large"
                    class="text-white rounded-lg"
                  >
                    Confirm
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </div>

        <!-- Overlay Panel -->
        <div class="overlay-container" v-if="isSmAndUp">
          <div class="overlay">
            <div class="overlay-panel overlay-center custom-overlay-light">
              <!-- LOGO -->
              <v-img
                :src="logo"
                height="160"
                width="100%"
                cover
                class="mb-1 pa-2"
                style="border-radius: 10px"
              />

              <!-- SDNHS BIG TITLE -->
              <div class="school-code-light mb-2">SDNHS</div>

              <!-- SYSTEM NAME -->
              <div class="system-title-light mb-3">Class Management System</div>

              <!-- TAGLINE -->
              <div class="tagline-light mb-6">
                "Nurturing Potentials, Inspiring Excellence, Building Futures"
              </div>

              <!-- BUTTONS -->
              <div class="d-flex justify-center mt-4">
                <v-btn
                  variant="outlined"
                  rounded="lg"
                  class="font-weight-bold mx-3"
                  append-icon="mdi-account"
                  width="150"
                  style="border-color: #e93175; color: #e93175"
                  @click="isLogin = true"
                >
                  Sign In
                </v-btn>

                <v-btn
                  variant="flat"
                  rounded="lg"
                  class="font-weight-bold mx-3"
                  append-icon="mdi-home"
                  width="150"
                  style="background: #e93175; color: white"
                  @click="doHome()"
                >
                  Home
                </v-btn>
              </div>
            </div>
            <div class="overlay-panel overlay-right custom-overlay">
              <!-- LOGO -->
              <v-img
                :src="logo"
                height="160"
                width="100%"
                cover
                class="mb-1 pa-2"
              />

              <!-- SDNHS BIG TITLE -->
              <div class="school-code mb-2">SDNHS</div>

              <!-- SYSTEM NAME -->
              <div class="system-title mb-3">Class Management System</div>

              <!-- TAGLINE -->
              <div class="tagline mb-6">
                "Nurturing Potentials, Inspiring Excellence, Building Futures"
              </div>

              <!-- OPTIONAL BUTTONS -->
              <div class="d-flex justify-center mt-4">
                <v-btn
                  variant="outlined"
                  rounded="lg"
                  class="font-weight-bold mx-3"
                  append-icon="mdi-account"
                  color="white"
                  width="150"
                  @click="isLogin = false"
                >
                  Sign Up
                </v-btn>

                <v-btn
                  variant="flat"
                  rounded="lg"
                  class="font-weight-bold mx-3"
                  append-icon="mdi-home"
                  width="150"
                  style="background: white; color: #e93175"
                  @click="doHome()"
                >
                  Home
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import { useDisplay } from 'vuetify';
export default {
  name: 'loginPage',
  data() {
    return {
      display: useDisplay(),
      logo: require('@/assets/img/records.png'),
      isLogin: true,
      mobile: true,
      isLoading: false,
      showPassword: false,
      showPasswordConfirm: false,
      step: { id: 1, name: 'Personal Information' },
      fname: null,
      lname: null,
      assignedModulesList: [],
      assignedModuleID: null,
      mname: null,
      name: '',
      email: '',
      otp: ['', '', '', '', '', ''],
      emailLogin: '',
      passwordLogin: '',
      password: '',
      emailError: '',
      confirmPassword: '',
      userType: null,
      fadeAwayMessage: {
        show: false,
        type: 'success',
        header: 'Successfully Added!',
        message: '',
        top: 10,
      },
    };
  },
  computed: {
    isSmAndUp() {
      return this.display.smAndUp;
    },
  },
  mounted() {
    this.getAssignedModules();
    this.userType = localStorage.getItem('userType');
  },
  methods: {
    mobileChange() {
      if (this.mobile == true) {
        this.mobile = false;
        const signUp = document.querySelector('.sign-up-container');
        const signIn = document.querySelector('.sign-in-container');
        if (signUp) {
          signUp.style.zIndex = '1';
          signUp.style.opacity = '100%';
          signIn.style.zIndex = '0';
          signIn.style.opacity = '0';
        }
      } else if (this.mobile == false) {
        this.mobile = true;
        const signUp = document.querySelector('.sign-up-container');
        const signIn = document.querySelector('.sign-in-container');
        if (signIn) {
          signUp.style.zIndex = '0';
          signUp.style.opacity = '0';
          signIn.style.zIndex = '1';
          signIn.style.opacity = '100%';
        }
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    dologin() {
      if (this.$refs.formLogin.validate()) {
        this.isLoading = true;
        let data = {
          email: this.emailLogin,
          password: this.passwordLogin,
        };
        this.axiosCall('/auth/login', 'POST', data).then((res) => {
          this.isLoading = false;
          if (
            res.data.status == 200 ||
            res.data.status == 201 ||
            res.data.status == 202
          ) {
            localStorage.setItem('token', res.data.token);
            this.isLoading = false;
            this.$store.commit('setExpiryDate');
            location.reload();
            // setTimeout(() => {
            //   axios({
            //     method: "GET",
            //     url: process.env.VUE_APP_SERVER + "/employee/my-details",

            //     headers: { Authorization: `Bearer ${res.data.token}` },
            //   }).then((resp) => {
            //     this.$store.dispatch("setEmp", resp.data);
            // }, 500);
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'error';
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = 'System Message';
          }
        });
      }
    },

    register() {
      // registration logic here
      if (this.password != this.confirmPassword) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = 'error';
        this.fadeAwayMessage.message = 'Password not mutch';
        this.fadeAwayMessage.header = 'System Message';
      } else {
        this.isLoading = true;
        if (this.$refs.formRegister.validate()) {
          let data = {
            fname: this.fname,
            mname: this.mname,
            lname: this.lname,
            user_roleID: this.userType == 0 ? 3 : 2,
            isAdminApproved: 1,
            usertypeID: 2,
            email: this.email,
            password: this.password,
            assignedModuleID: this.userType == 1 ? this.assignedModuleID : 22,
          };
          this.axiosCall('/auth/registerUser', 'POST', data).then((res) => {
            if (res.data.status == 201) {
              this.isLoading = false;
              this.$store.dispatch('setEmail', this.email);
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = 'success';
              this.fadeAwayMessage.message =
                'We’ve sent an OTP to your email. Please enter it to confirm your login.';
              this.fadeAwayMessage.header = 'System Message';
              // this.isLogin = true;
              // this.refresh();
              this.next();
              // this.$router.push("/login");
            } else {
              this.isLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = 'error';
              this.fadeAwayMessage.message = res.data.message;
              this.fadeAwayMessage.header = 'System Message';
              this.animated = true;
            }
          });
        }
      }
    },

    checkEmail() {
      this.emailChecking = true;
      this.axiosCall('/auth/checkEmailIfExist/' + this.email, 'GET').then(
        (res) => {
          console.log(res.data);
          if (res.data) {
            this.emailError = 'Email Already Exist!';
          } else {
            this.emailError = '';
          }
          this.emailChecking = false;
        },
      );
    },
    refresh() {
      this.lname = null;
      this.fname = null;
      this.mname = null;
      this.email = null;
      this.password = null;
    },
    next() {
      if (this.step.id == 1) {
        if (this.$refs.formInformation.validate()) {
          if (this.fname == null || this.lname == null) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'error';
            this.fadeAwayMessage.message = 'Please fill-up required fields!';
            this.fadeAwayMessage.header = 'System Message';
          } else {
            this.step = { id: 2, name: 'Account Information' };
          }
        }
      }
      //  else if (this.step.id == 2) {
      //   if (this.$refs.Step2Formref.validate()) {
      //     this.step = { id: 3, name: "Account Information" };
      //   }
      // }
      else if (this.step.id == 2) {
        if (this.$refs.formRegister.validate()) {
          this.step = { id: 3, name: 'Otp Confirmation' };
        }
      }
    },

    getAssignedModules() {
      this.axiosCall('/assigned-modules/getSpecificModules', 'GET').then(
        (res) => {
          // console.log("AssignedM", res.data);
          this.assignedModulesList = res.data;
        },
      );
    },
    // focusNext(index) {
    //   console.log(index);
    //   if (this.otp[index] && index < this.otp.length - 1) {
    //     const inputs = document.querySelectorAll(".otp-input input");
    //     inputs[index + 1]?.focus();
    //   }
    // },

    onOtpInput(event, index) {
      const value = event.target.value.replace(/\D/g, '').slice(0, 1);
      this.otp[index] = value;

      if (value && index < this.otp.length - 1) {
        const inputs = document.querySelectorAll('.otp-input');
        inputs[index + 1]?.focus();
      }
    },

    submitOTP() {
      this.isLoading = true;
      const otpValue = this.otp.join('');

      if (otpValue.length !== 6) {
        alert('Please enter complete OTP');
        return;
      }

      // 🔗 Call your API here
      console.log('OTP:', otpValue);
      let data = {
        email: this.$store.getters.getEmail,
        otp: otpValue,
      };
      this.axiosCall('/auth/confirmOtp', 'POST', data).then((res) => {
        if (res.data.status == 200) {
          this.isLoading = false;
          this.isLogin = true;
          this.refresh();
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = 'success';
          this.fadeAwayMessage.message =
            'Your OTP has been successfully confirmed. You may now proceed to log in.';
          this.fadeAwayMessage.header = 'System Message';
          this.otp = ['', '', '', '', '', ''];
          this.step = { id: 1, name: 'Personal Information' };
          setTimeout(() => {
            this.$router.push('/login');
          }, 2000);
          // this.$router.push("/registration-success");
        } else {
          this.isLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = 'error';
          this.fadeAwayMessage.message = res.data.msg;
          this.fadeAwayMessage.header = 'System Message';
        }
      });

      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    doHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.auth-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #fff5f9, #ffffff);
}

.auth-wrapper {
  background: #fff;
  width: 900px;
  max-width: 100%;
  min-height: 600px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  display: flex;
  transition: all 0.6s ease-in-out;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  z-index: 1;
}
@media (min-width: 768px) {
  .form-container {
    width: 50%;
    padding: none;
  }
  .auth-wrapper {
    min-height: 550px;
  }
}

.sign-in-container {
  left: 0;
}
.sign-up-container {
  left: 0;
  opacity: 0;
  z-index: 0;
}

.auth-wrapper.right-panel-active .sign-in-container {
  transform: translateX(100%);
  opacity: 0;
}

.auth-wrapper.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
}

.form-card {
  width: 360px;
  padding: 40px;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
  z-index: 100;
}

.overlay {
  background: linear-gradient(to right, #f8f9fa, #e93175);
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: all 0.6s ease-in-out;
  display: flex;
}

.auth-wrapper.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

.auth-wrapper.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay-panel {
  width: 50%;
  padding: 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.overlay-left {
  transform: translateX(-20%);
}

.overlay-right {
  transform: translateX(0);
}

/* Step indicator */
.step-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f0e3ea;
  color: #b0879a;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.25s ease;
}
.step-dot-active {
  background: #e93175;
  color: white;
  box-shadow: 0 0 0 4px rgba(233, 49, 117, 0.15);
}
.step-dot-done {
  background: #e93175;
}
.step-line {
  width: 28px;
  height: 2px;
  background: #f0e3ea;
  margin: 0 4px;
  transition: all 0.25s ease;
}
.step-line-done {
  background: #e93175;
}

.otp-wrapper {
  display: flex;
  justify-content: center;
  gap: 8px;
  color: black;
}
.otp-input {
  border: 2px solid;
  border-color: #ff53cc;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  margin-right: 2px;
  margin-left: 2px;
  font-size: 28px;
  text-align: center;
  transition: box-shadow 0.2s ease;
}
.otp-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255, 83, 204, 0.25);
}

.custom-overlay {
  background: linear-gradient(135deg, #e93175, #d81b60);
  color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

/* SDNHS big stylized text */
.school-code {
  font-size: 42px;
  font-weight: 800;
  letter-spacing: 6px;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

/* System name */
.system-title {
  font-size: 20px;
  font-weight: 600;
}

/* Script-style tagline */
.tagline {
  font-size: 14px;
  font-style: italic;
  opacity: 0.9;
}
.custom-overlay-light {
  background: white;
  color: #e93175;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

/* SDNHS stylized */
.school-code-light {
  font-size: 42px;
  font-weight: 900;
  letter-spacing: 6px;
  color: #e93175;
  text-shadow: 0 0 5px #ffc1dc, 0 0 10px #ff9ecf;
}

/* System title */
.system-title-light {
  font-size: 20px;
  font-weight: 600;
}

/* Tagline */
.tagline-light {
  font-size: 14px;
  font-style: italic;
  opacity: 0.8;
}
</style>
